// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PaymentInfoStep_cards-row__XMwA7, .PaymentInfoStep_open-pay-info-row__s\\+uDC {
  display: flex;
  flex-direction: row;
}

.PaymentInfoStep_credit-card-logos-column__-e7cW {
  width: 30%;
  align-items: flex-start;
}

.PaymentInfoStep_debit-card-logos-column__V7G0d {
  width: 70%;
  align-items: flex-start;
}

.PaymentInfoStep_payment-half-width-col__4Q\\+gp {
  display: inline-flex;
  width: 50%;
}

.PaymentInfoStep_cards-row__XMwA7 {
  display: flex;
  flex-direction: row;
}

.PaymentInfoStep_open-pay-logo-column__D6edo {
  width: 25%;
  align-items: center;
  border-right: 1px solid #7f7f7f;
}
.PaymentInfoStep_open-pay-logo-column__D6edo img {
  max-width: 80%;
}

.PaymentInfoStep_open-pay-encryption-column__InZuk {
  display: flex;
  flex-direction: row;
  width: 75%;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/views/Payment/PaymentSteps/PaymentInfoStep/PaymentInfoStep.module.scss"],"names":[],"mappings":"AAGA;EACI,aAAA;EACA,mBAAA;AAFJ;;AAKA;EACI,UAAA;EACA,uBAAA;AAFJ;;AAKA;EACI,UAAA;EACA,uBAAA;AAFJ;;AAKA;EACI,oBAAA;EACA,UAAA;AAFJ;;AAIA;EACI,aAAA;EACA,mBAAA;AADJ;;AAIA;EACI,UAAA;EACA,mBAAA;EAIA,+BAAA;AAJJ;AACI;EACI,cAAA;AACR;;AAIA;EACI,aAAA;EACA,mBAAA;EACA,UAAA;EACA,mBAAA;AADJ","sourcesContent":["@use \"styles/typography\";\n@use \"styles/colors\";\n\n.cards-row, .open-pay-info-row {\n    display: flex;\n    flex-direction: row;\n}\n\n.credit-card-logos-column {\n    width: 30%;\n    align-items: flex-start;\n}\n\n.debit-card-logos-column {\n    width: 70%;\n    align-items: flex-start;\n}\n\n.payment-half-width-col {\n    display: inline-flex;\n    width: 50%\n}\n.cards-row {\n    display: flex;\n    flex-direction: row;\n}\n\n.open-pay-logo-column {\n    width: 25%;\n    align-items: center;\n    img {\n        max-width: 80%;\n    }\n    border-right: 1px solid #7f7f7f;\n}\n\n.open-pay-encryption-column {\n    display: flex;\n    flex-direction: row;\n    width: 75%;\n    align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cards-row": `PaymentInfoStep_cards-row__XMwA7`,
	"open-pay-info-row": `PaymentInfoStep_open-pay-info-row__s+uDC`,
	"credit-card-logos-column": `PaymentInfoStep_credit-card-logos-column__-e7cW`,
	"debit-card-logos-column": `PaymentInfoStep_debit-card-logos-column__V7G0d`,
	"payment-half-width-col": `PaymentInfoStep_payment-half-width-col__4Q+gp`,
	"open-pay-logo-column": `PaymentInfoStep_open-pay-logo-column__D6edo`,
	"open-pay-encryption-column": `PaymentInfoStep_open-pay-encryption-column__InZuk`
};
export default ___CSS_LOADER_EXPORT___;
